import { MAP_MARKER_PATH, MAP_MARKER_COLOR, MAP_LABEL_COLOR, MAP_LABEL_FONT_SIZE } from "../utilities/constants";

const debounce = require("lodash/debounce");

/**
 * @function
 * @desctiption - Appends the error message to the element
 * @param {Element} element - Erroe message element
 * @param {String} errorType - Error message
 */
const appendError = (element, errorType) => {
    let $errorMsgArea = $(".coverage-area-error");
    let $this = $(element);
    const $errorMsgInput = $("#coverage-postal-code");
    if ($this.length) {
        let error = $this.attr(errorType);
        let msg = (error) ? error : errorType;

        //GTM logic - Start
        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
            detail: {
                "success": false,
                "messageContent": msg
            }
        }));
        //GTM logic - End

        $errorMsgArea.empty().html(msg).removeClass("d-none");
        $errorMsgInput.empty().addClass("is-invalid");
        $("#coverage-postal-code").focus();
    }
};

/**
 * @private
 * @function
 * @description - Returns marker of customer current position
 * @param {String} mapSelector - map container selector
 */
const getMap = mapSelector => {
    let google = window.google;
    let mapOptions = {
        zoom: 6
    };

    let map = new google.maps.Map(document.getElementById(mapSelector), mapOptions);

    return map;
};

/**
 * @function
 * @description - Create custom store markers on the map
 * @param {String} color - The color of the custom marker
 */
const mapMarkerIcon = color => {
    const google = window.google;

    return {
        path: MAP_MARKER_PATH,
        fillColor: color,
        fillOpacity: 1,
        strokeColor: color,
        strokeWeight: 1,
        scale: 2,
        size: new google.maps.Size(22, 30),
        anchor: new google.maps.Point(4, 16),
        labelOrigin: new google.maps.Point(5.5, 6)
    };
};

/**
 * @private
 * @function
 * @description - Returns marker of store
 * @param {Object} store - Store object
 * @param {Object} map - Map object
 */
const getStoreMarker = (store, map) => {
    const google = window.google;
    const position = {lat: store.data("delivery-latitude"), lng: store.data("delivery-longitude")};
    const storeIndex = parseInt(store.data("index"), 10).toString();

    let storeLocation = new google.maps.Marker({
        icon: mapMarkerIcon(MAP_MARKER_COLOR),
        label: {
            text: storeIndex,
            color: MAP_LABEL_COLOR,
            fontSize: MAP_LABEL_FONT_SIZE
        },
        position: position,
        map: map,
        optimized: false,
        zIndex: 1
    });

    storeLocation.addListener("click", function () {
        const $storeElement = $(`.store-details[data-index="${this.label.text}"], .js-store-details[data-index="${this.label.text}"]`);
        const $storeMarker = $storeElement.find(".store-marker");
        const $checkoutStoreCheckbox = $storeElement.find(".pwc-form-check-input");

        if ($storeMarker.length > 0) {
            $(".store-info").empty().html($storeMarker.parent().find(".store-detailed-info").html());
        }

        if ($checkoutStoreCheckbox.length > 0) {
            $checkoutStoreCheckbox.trigger("click");
        }

    });

    return storeLocation;
};

/**
 * @private
 * @function
 * @description - Gets nearest stores and calculates distance to selected delivery point
 * @param {Object} $modal - Modal where Stores are placed
 */
const setStoresDistance = $modal => {
    const stores = $modal.find(".delivery-nearest .store-distance");
    const searchPos = $modal.find(".search-coordinates");
    const searchLatitude = searchPos.data("search-coordinates-latitude");
    const searchLongitude = searchPos.data("search-coordinates-longitude");
    const google = window.google;
    const origin = new google.maps.LatLng(searchLatitude, searchLongitude);

    stores.each((index, element) => {
        const $store = $(element);
        const storeDetails = $store.parent().data("storedetails");
        const distanceUnit = $store.data("distance-unit");
        const destination = new google.maps.LatLng(storeDetails.latitude, storeDetails.longitude);
        const distance = (google.maps.geometry.spherical.computeDistanceBetween(origin, destination) * 0.001).toFixed(2);
        $store.text(`${parseInt(distance, 10)} ${distanceUnit}`);
    });
};

/**
 * @function
 * @description - Initialize postal code input buttons events
 * @param {String} modal - modal selector
 */
const initPostalCodeInputButtons = modal => {
    if ($(modal).length == 0) { return; }

    const $coveragePostalCodeInput = document.querySelector(modal + " #coverage-postal-code");

    $coveragePostalCodeInput.addEventListener("keyup", e => {
        const $postalCodeInput = e.target;

        document.querySelectorAll(".delete-postal-code").forEach(btn => { btn.classList.toggle("d-none", $postalCodeInput.value == ""); });
    });

    $coveragePostalCodeInput.addEventListener("focusout", debounce(() => {
        document.querySelectorAll(".delete-postal-code").forEach(btn => btn.classList.add("d-none"));
    }, 200));

    $coveragePostalCodeInput.addEventListener("focusin", e => {
        const $postalCodeInput = e.currentTarget;

        if ($postalCodeInput.value !== "") {
            document.querySelectorAll(".delete-postal-code").forEach(btn => btn.classList.remove("d-none"));
        }
    });

    $(".coverage-postal-container").on("touchstart click", ".delete-postal-code", () => {
        $coveragePostalCodeInput.value = "";
        $coveragePostalCodeInput.classList.remove("filled");
        $coveragePostalCodeInput.focus();

        document.querySelectorAll(".delete-postal-code").forEach(btn => { btn.classList.add("d-none"); });
    });

    $(".coverage-postal-container").off("touchstart click", ".submit-postal-code").on("touchstart click", ".submit-postal-code", e => {
        e.preventDefault();

        $(modal).find(".coverage-area-form").submit();

        const ptPostalCodeRegex = /^\d{4}(-\d{3})?$/;
        if ($("#coverage-postal-code").val().match(ptPostalCodeRegex)) {
            $(".search-postal-code").find(".pwc-form-check-label").text($("#coverage-postal-code").val());
        }

        if (($("#coverage-postal-code").val() !== "")) $(".delivery-area").addClass("postal-searched");
    });
};

export { appendError, getMap, getStoreMarker, mapMarkerIcon, setStoresDistance, initPostalCodeInputButtons };
